/* Minero 2027 – storefront interactions (vanilla, no deps) */
(() => {
  const doc = document.documentElement;
  doc.classList.add('mc-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const v = (cents / 100);
    return '$' + (Number.isInteger(v) ? v.toFixed(0) : v.toFixed(2));
  };

  /* ---------- reveal on scroll ---------- */
  const revealAll = () => $$('[data-reveal]').forEach((el) => el.classList.add('is-in'));
  if (reduce || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    const observe = (root = document) => $$('[data-reveal]:not(.is-in)', root).forEach((el) => io.observe(el));
    observe();
    document.addEventListener('shopify:section:load', (e) => observe(e.target));
  }
  requestAnimationFrame(() => doc.classList.add('mc-ready'));

  /* ---------- header: scrolled state ---------- */
  const header = $('[data-mc-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  const drawer = $('[data-mc-drawer]');
  const openBtn = $('[data-mc-menu-open]');
  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    openBtn && openBtn.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('mc-lock', open);
    if (open) { const f = $('a, button', drawer.querySelector('.mc-drawer__panel')); f && f.focus(); }
    else openBtn && openBtn.focus();
  };
  openBtn && openBtn.addEventListener('click', () => setDrawer(true));
  $$('[data-mc-menu-close]').forEach((b) => b.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false); });

  /* ---------- subtle parallax on hero ---------- */
  const par = $('[data-mc-parallax]');
  if (par && !reduce) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = Math.min(window.scrollY, 900);
        par.style.transform = `translate3d(0, ${y * 0.18}px, 0) scale(1.06)`;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- add to cart (quick add + product form) ---------- */
  const cartDrawer = () => document.querySelector('cart-drawer');
  async function addToCart(form, btn) {
    const drawerEl = cartDrawer();
    const fd = new FormData(form);
    if (drawerEl) {
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
    }
    btn && btn.classList.add('is-loading');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', body: fd, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      if (drawerEl && typeof drawerEl.renderContents === 'function') {
        drawerEl.classList.remove('is-empty');
        drawerEl.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      btn && btn.classList.add('is-added');
      setTimeout(() => btn && btn.classList.remove('is-added'), 1600);
    } catch (err) {
      console.error(err);
      toast(err.message || 'Something went wrong');
    } finally {
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-mc-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  function toast(msg) {
    let t = $('.mc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mc-toast'; t.setAttribute('role', 'alert'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-on'), 3200);
  }

  /* ---------- filters (roast + flavor + sort) ---------- */
  $$('[data-mc-filter-scope]').forEach((scope) => {
    const items = $$('[data-mc-item]', scope);
    const countEl = $('[data-mc-count]', scope);
    const empty = $('[data-mc-empty]', scope);
    const grid = $('[data-mc-grid]', scope) || (items[0] && items[0].parentElement);
    let roast = 'all';
    const flavors = new Set();
    const apply = () => {
      let n = 0;
      items.forEach((it) => {
        const okR = roast === 'all' || it.dataset.roast === roast;
        const f = (it.dataset.flavors || '').split(' ');
        const okF = !flavors.size || [...flavors].every((x) => f.includes(x));
        const show = okR && okF;
        it.hidden = !show;
        if (show) { n++; it.classList.remove('is-pop'); void it.offsetWidth; it.classList.add('is-pop'); }
      });
      if (countEl) countEl.textContent = `${n} coffee${n === 1 ? '' : 's'}`;
      if (empty) empty.hidden = n !== 0;
    };
    $$('[data-mc-roast]', scope).forEach((b) => b.addEventListener('click', () => {
      roast = b.dataset.mcRoast;
      $$('[data-mc-roast]', scope).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      apply();
    }));
    $$('[data-mc-flavor]', scope).forEach((b) => b.addEventListener('click', () => {
      const v = b.dataset.mcFlavor;
      flavors.has(v) ? flavors.delete(v) : flavors.add(v);
      b.classList.toggle('is-active', flavors.has(v));
      b.setAttribute('aria-pressed', String(flavors.has(v)));
      apply();
    }));
    $$('[data-mc-reset]', scope).forEach((b) => b.addEventListener('click', () => {
      roast = 'all'; flavors.clear();
      $$('[data-mc-roast]', scope).forEach((x) => { const on = x.dataset.mcRoast === 'all'; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
      $$('[data-mc-flavor]', scope).forEach((x) => { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
      apply();
    }));
    const sort = $('[data-mc-sort]', scope);
    if (sort && grid) {
      items.forEach((it, i) => (it.dataset.order = i));
      sort.addEventListener('change', () => {
        const v = sort.value;
        const sorted = [...items].sort((a, b) => {
          if (v === 'price-asc') return a.dataset.price - b.dataset.price;
          if (v === 'price-desc') return b.dataset.price - a.dataset.price;
          return a.dataset.order - b.dataset.order;
        });
        sorted.forEach((it) => grid.appendChild(it));
      });
    }
    if (countEl) countEl.textContent = `${items.length} coffee${items.length === 1 ? '' : 's'}`;
  });

  /* ---------- roast quiz ---------- */
  $$('[data-mc-quiz]').forEach((quiz) => {
    let data = [];
    try { data = JSON.parse($('[data-mc-quiz-data]', quiz).textContent); } catch (e) { return; }
    const form = $('[data-mc-quiz-form]', quiz);
    const steps = $$('.mc-quiz__step', quiz);
    const dots = $$('.mc-quiz__progress li', quiz);
    const back = $('[data-mc-quiz-back]', quiz);
    const result = $('[data-mc-quiz-result]', quiz);
    let step = 0;
    const show = (i) => {
      step = i;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k <= i));
      back.hidden = i === 0;
    };
    form.addEventListener('change', (e) => {
      if (e.target.type !== 'radio') return;
      setTimeout(() => { step < steps.length - 1 ? show(step + 1) : finish(); }, reduce ? 0 : 260);
    });
    back.addEventListener('click', () => show(Math.max(0, step - 1)));
    function finish() {
      const a = Object.fromEntries(new FormData(form));
      const roastPref = { light: { light: 3, medium: 1, dark: 0 }, medium: { light: 1, medium: 3, dark: 1 }, dark: { light: 0, medium: 1, dark: 3 } }[a.q3] || {};
      const drink = { black: { light: 1, medium: 1, dark: 0 }, milk: { light: 0, medium: 1, dark: 2 }, cold: { light: 0, medium: 2, dark: 1 } }[a.q1] || {};
      const scored = data.filter((p) => p.available).map((p) => {
        const f = (p.flavors || '').split(' ');
        let s = (roastPref[p.roast] || 0) + (drink[p.roast] || 0) + (f.includes(a.q2) ? 3 : 0);
        return { ...p, s };
      }).sort((x, y) => y.s - x.s);
      const [best, ...rest] = scored;
      if (!best) return;
      const card = (p, big) => `
        <article class="mc-qres${big ? ' mc-qres--big' : ''}">
          <a href="${p.url}" class="mc-qres__img"><img src="${p.image}" alt="${p.title}" loading="lazy"></a>
          <div class="mc-qres__body">
            ${big ? '<p class="mc-eyebrow mc-eyebrow--saffron">Your match</p>' : ''}
            <h3><a href="${p.url}">${p.title}</a></h3>
            <p class="mc-qres__meta">${p.roast.charAt(0).toUpperCase() + p.roast.slice(1)} roast · ${p.price}</p>
            ${big ? `<p class="mc-qres__notes">${p.notes}</p><p class="mc-qres__hook">${p.hook}</p>` : ''}
            <form action="/cart/add" method="post" data-mc-add>
              <input type="hidden" name="id" value="${p.variant}"><input type="hidden" name="quantity" value="1">
              <button type="submit" class="mc-btn ${big ? 'mc-btn--saffron' : 'mc-btn--outline mc-btn--sm'}">Add to cart${big ? ' · whole bean' : ''}</button>
            </form>
          </div>
        </article>`;
      result.innerHTML = `${card(best, true)}<div class="mc-qres__more"><p class="mc-pdp__label">Also try</p>${rest.slice(0, 2).map((p) => card(p)).join('')}</div><button type="button" class="mc-link mc-qres__retake" data-mc-quiz-retake>↺ Retake the quiz</button>`;
      form.hidden = true; result.hidden = false; result.focus({ preventScroll: true });
      dots.forEach((d) => d.classList.add('is-on'));
      $('[data-mc-quiz-retake]', result).addEventListener('click', () => { form.reset(); form.hidden = false; result.hidden = true; show(0); });
    }
  });

  /* ---------- reviews rail ---------- */
  $$('[data-mc-rail]').forEach((rail) => {
    const sec = rail.closest('section');
    const by = () => Math.min(rail.clientWidth * 0.8, 520);
    $('[data-mc-rail-prev]', sec) && $('[data-mc-rail-prev]', sec).addEventListener('click', () => rail.scrollBy({ left: -by(), behavior: reduce ? 'auto' : 'smooth' }));
    $('[data-mc-rail-next]', sec) && $('[data-mc-rail-next]', sec).addEventListener('click', () => rail.scrollBy({ left: by(), behavior: reduce ? 'auto' : 'smooth' }));
  });

  /* ---------- bundle demo bar ---------- */
  $$('.mc-ship__bar--demo').forEach((bar) => {
    if (!('IntersectionObserver' in window)) return bar.classList.add('is-run');
    const o = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { bar.classList.add('is-run'); o.disconnect(); } }), { threshold: 0.4 });
    o.observe(bar);
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-mc-product]');
  if (pdp) {
    let product = null;
    try { product = JSON.parse($('[data-mc-product-json]', pdp).textContent); } catch (e) {}
    const form = $('#mc-product-form', pdp);
    const idInput = $('[data-mc-variant-id]', pdp);
    const priceEl = $('[data-mc-price]', pdp);
    const atc = $('[data-mc-atc]', pdp);
    const atcLabel = $('[data-mc-atc-label]', pdp);
    const atcPrice = $('[data-mc-atc-price]', pdp);
    const sticky = $('[data-mc-sticky]', pdp);
    const stickyPrice = $('[data-mc-sticky-price]', pdp);
    const stickyVariant = $('[data-mc-sticky-variant]', pdp);
    const groups = $$('[data-mc-option]', pdp);

    const selected = () => groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const update = () => {
      if (!product) return;
      const sel = selected();
      groups.forEach((g, i) => { const v = $('[data-mc-option-value]', g); if (v) v.textContent = sel[i]; });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      if (!variant) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = variant.id;
      priceEl.textContent = money(variant.price);
      atcPrice.textContent = money(variant.price);
      stickyPrice && (stickyPrice.textContent = money(variant.price));
      stickyVariant && (stickyVariant.textContent = variant.option2 || variant.title);
      atc.disabled = !variant.available;
      atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      // availability per value (for grind pills)
      groups.forEach((g, gi) => {
        $$('input', g).forEach((inp) => {
          const test = sel.slice(); test[gi] = inp.value;
          const v = product.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.closest('.mc-pill').classList.toggle('is-out', !v || !v.available);
        });
      });
    };
    groups.forEach((g) => g.addEventListener('change', update));
    update();

    $$('[data-mc-qty]', pdp).forEach((b) => b.addEventListener('click', () => {
      const inp = $('[data-mc-qty-input]', pdp);
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.mcQty, 10));
    }));

    // gallery
    const stage = $('[data-mc-gallery-stage]', pdp);
    const slides = $$('.mc-gallery__slide', pdp);
    const thumbs = $$('[data-mc-thumb]', pdp);
    const dots = $$('.mc-gallery__dots span', pdp);
    const setActive = (i) => {
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = +t.dataset.mcThumb;
      setActive(i);
      if (window.matchMedia('(max-width: 989px)').matches && slides[i]) stage.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }));
    if (stage) {
      stage.addEventListener('scroll', () => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        const i = Math.round(stage.scrollLeft / stage.clientWidth);
        setActive(Math.min(slides.length - 1, Math.max(0, i)));
      }, { passive: true });
    }

    // tabs
    $$('[data-mc-tabs]', pdp).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const activate = (t) => {
        tabs.forEach((x) => {
          const on = x === t;
          x.classList.toggle('is-active', on); x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
          const p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) { p.hidden = !on; p.classList.toggle('is-active', on); }
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => activate(t));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            activate(n); n.focus();
          }
        });
      });
    });

    // sticky add to cart (mobile)
    if (sticky && atc) {
      const btn = $('[data-mc-sticky-btn]', sticky);
      let tick = false;
      const check = () => {
        tick = false;
        const r = atc.getBoundingClientRect();
        const show = r.bottom < 0;
        if (show === sticky.classList.contains('is-on')) return;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', String(!show));
        btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('mc-sticky-on', show);
      };
      window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      btn.addEventListener('click', () => (form.requestSubmit ? form.requestSubmit() : form.submit()));
    }
  }
})();
